<template>
	<div class="page mygroupwork_page">
		<div class="w1200">
			<div class="block30"></div>
			<div class="back_typebox" @click="sysgoback()">
				<img class="icon" src="../assets/static/leftgo.png"/>
				<div class="text fontsize16">返回上一页</div>
			</div>
			<div class="block30"></div>
			<div class="mygroupwork_typebox">
				<div class="line"></div>
				<div class="text fontsize32">{{zyssobj.title}}</div>
				<div class="ysjl_box" @click="showtexttc = true">
					<img class="icon" src="../assets/badge/month.png"/>
					<div class="text fontsize20">月赛记录</div>
				</div>
			</div>
			<div class="block20"></div>
			<div class="topbox">
				<div class="itemlist fontsize16">
					<div class="itemobj">
						<div class="text1">开始时间</div>
						<div class="text2">{{zyssobj.examStartTime}}</div>
					</div>
					<!-- <div class="itemobj">
						<div class="text1">类型</div>
						<div class="text2">{{zyssobj.infoTags}}</div>
					</div> -->
					<div class="itemobj">
						<div class="text1">结束时间</div>
						<div class="text2">{{zyssobj.examEndTime}}</div>
					</div>
					<div class="itemobj">
						<div class="text1">状态</div>
						<div class="text2" v-if="zyssobj.typeTag=='ing'">进行中</div>
						<div class="text2" v-if="zyssobj.typeTag=='end'">已结束</div>
						<div class="text2" v-if="zyssobj.typeTag=='before'">未开始</div>
						<div class="text2" v-if="zyssobj.typeTag=='on'">补做中</div>
					</div>
				</div>
				<!-- <div class="textbox">
					<div class="text1 fontsize20">描述</div>
					<div class="text2 fontsize16">{{zyssobj.discription}}</div>
				</div> -->
			</div>
			<div class="block20"></div>
			<div class="centerbox">
				<div class="typebox fontsize16">
					<div class="itemobj" :class="{'active':typeindex==0}" @click="handletype(0)">
						<div class="text">问题情况</div>
						<div class="line"></div>
					</div>
				</div>
			</div>
			<div class="block20"></div>
			<div class="bottombox">
				<div class="w100" v-if="typeindex==0">
					<div class="item1 fontsize14">
						<div class="text1">序号</div>
						<div class="text2">题号</div>
						<div class="text3">题目名称</div>
						<!-- <div class="text4">完成人数</div> -->
						<div class="text5">完成情况</div>
					</div>
					<div class="item2 fontsize14" v-for="(item,index) in questionlist" :key="index" @click="gotoworkdetail(index)">
						<div class="text1">{{index+1}}</div>
						<div class="text2">{{item.questNumber}}</div>
						<div class="text3 pointer">{{item.title}}</div>
						<!-- <div class="text4">{{item.successNum}}</div> -->
						<div class="text5" v-if="item.hlQuestExamRecordDetail">
							<span class="c1" v-if="item.hlQuestExamRecordDetail.recordStatus==0">正确</span>
							<span class="c2" v-if="item.hlQuestExamRecordDetail.recordStatus==1">错误</span>
							<span class="c3" v-if="item.hlQuestExamRecordDetail.recordStatus==-1">未开始</span>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<div class="block30"></div>
		<!-- 月赛记录 -->
		<el-dialog title="月赛记录" width="868px" top="5vh" :visible.sync="showtexttc" :close-on-click-modal="false">
			<div class="recordsList_box">
				<div class="itemobj fontsize14">
					<div class="text1">标题</div>
					<div class="text2">状态</div>
					<div class="text3">开始时间</div>
					<div class="text4">结束时间</div>
					<div class="text5"></div>
				</div>
				<div class="itemobj1 fontsize14" v-for="(item,index) in recordsList" :key="index">
					<div class="text1">{{item.title}}</div>
					<div class="text2">
						<span class="c1" v-if="item.typeTag=='ing'">进行中</span>
						<span class="c2" v-if="item.typeTag=='end'">已结束</span>
						<span class="c3" v-if="item.typeTag=='before'">未开始</span>
						<span class="c2" v-if="item.typeTag=='on'">补做中</span>
					</div>
					<div class="text3">{{item.examStartTime}}</div>
					<div class="text4">{{item.examEndTime}}</div>
					<div class="text5" @click="handleworkDetail(item.id)">查看详情</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top: 28px;">
			    <el-button @click="showtexttc = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data() {
		return {
			uid:null,//社团作业id
			zyssobj:{},//作业详情，
			typeindex:0,//0问题列表 1完成情况 3是榜单
			questionlist:[],//问题列表
			resultlist:[],//完成情况
			examUserSumList:[],//参赛人员得分统计
			showtexttc:false,//弹窗显示
			showtextCon:"",//弹窗显示我的输入代码
			recordsList:[],//月赛记录
		};
	},
	mounted: function() {
		if(this.isLogin){
			//获取详情
			this.getgroupDetail()
		}
	},
	computed: {
		...mapState(['userInfo', 'isLogin','sysRole']),
	},
	methods: {
		//跳转详情
		gotoworkdetail(quesindex){
			// if(this.zyssobj.typeTag=="before"){
			// 	this.$message.info("答题时间未开始！")
			// 	return false;
			// }
			// if(this.zyssobj.typeTag=="end"){
			// 	this.$message.info("答题时间已结束！")
			// 	return false;
			// }
			// ing
			if(quesindex){
				this.$router.push({
					path: "/monthworkdetail",
					query:{
						uid:this.uid,
						index:quesindex
					}
				});
			}else{
				this.$router.push({
					path: "/monthworkdetail",
					query:{
						uid:this.uid,
					}
				});
			}
		},
		//获取详情和获取问题列表
		getgroupDetail(){
			var _this = this
			var params = {
				currentPage:1,
				pageSize:888,
				userUuid:this.userInfo.uuid
			}
			this.$http.post('app/hlexam/hlMonthQuestExam/index', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					if(res.data.records&&res.data.records.length>0){
						res.data.records.forEach((item, index) => {
							const examStartTime = _this.$util.getDateTime2(item.examStartTime)
							const examEndTime = _this.$util.getDateTime2(item.examEndTime)
							try{
								item["typeTag"] = _this.$util.compareTimes(examStartTime,examEndTime)
							}catch(e){
								item["typeTag"] = ""
							}
						});
						_this.recordsList = res.data.records
						//查询问题详情
						_this.getmonthDetail(res.data.records[0].id)
					}
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		handleworkDetail(uid){
			this.showtexttc = false
			this.getmonthDetail(uid)
		},
		//查询问题详情
		getmonthDetail(uid){
			var _this = this
			this.uid = uid
			var params = {
				examId:uid,
				userUuid:this.userInfo.uuid
			}
			this.$http.post('app/hlexam/hlMonthQuestExam/toDetail', params).then(function(res) {
				//数据处理
				if (res.code == 200) {
					if(res.data){
						var dataobj = res.data
						var examStartTime = _this.$util.getDateTime2(dataobj.examStartTime)
						var examEndTime = _this.$util.getDateTime2(dataobj.examEndTime)
						try{
							dataobj["typeTag"] = _this.$util.compareTimes(examStartTime,examEndTime)
						}catch(e){
							dataobj["typeTag"] = ""
						}
						//自己的做题情况
						if(dataobj.questInfoList){
							dataobj.questInfoList.forEach((item, index) => {
								if(!item.hlQuestExamRecordDetail){
									item.hlQuestExamRecordDetail = {
										recordStatus:-1 //未开始
									}
								}
							});
							_this.questionlist = dataobj.questInfoList
						}
						_this.zyssobj = dataobj
					}
				} else {
					_this.$confirm(res.message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
			})
		},
		//类型
		handletype(type){
			this.typeindex = type
		},
		
		
	}
};
</script>
<style lang="scss" scoped>
	.ysjl_box{
		margin-left: auto;
		display: flex;
		align-items: center;
		cursor: pointer;
		.icon{
			width: 24px;
			height: 24px;
		}
		.text{
			margin-left: 5px;
		}
	}
	.recordsList_box{
		width: 100%;
		max-height: 688px;
		overflow-y: auto;
		border-radius: 12px;
		background: #FFF;
		box-shadow: 0px 4px 7px 0px rgba(187, 200, 236, 0.25);
		padding: 24px;
		box-sizing: border-box;
		.typebox{
			width: 100%;
			display: flex;
			align-items: center;
			.line{
				width: 3px;
				height: 24px;
				border-radius: 6px;
				background: #1682FD;
			}
			.text{
				margin-left: 16px;
			}
		}
		.itemobj{
			width: 100%;
			height: 48px;
			display: flex;
			align-items: center;
			.text1{
				width: 30%;
			}
			.text2{
				width: 10%;
				text-align: center;
			}
			.text3{
				width: 25%;
				text-align: center;
			}
			.text4{
				width: 25%;
				text-align: center;
			}
			.text5{
				flex: 1;
			}
		}
		.itemobj1{
			width: 100%;
			height: 48px;
			display: flex;
			align-items: center;
			border-top: 1px solid #EBEBEB;
			.text1{
				width: 30%;
				color: #222;
			}
			.text2{
				width: 10%;
				text-align: center;
				.c1{
					color: #1682FD;
				}
				.c2{
					color: #666;
				}
			}
			.text3{
				width: 25%;
				color: #666;
				text-align: center;
			}
			.text4{
				width: 25%;
				color: #666;
				text-align: center;
			}
			.text5{
				width: 10%;
				height: 32px;
				line-height: 32px;
				text-align: center;
				border-radius: 4px;
				background: linear-gradient(163deg, #449BFF 12.87%, #1682FD 89.68%);
				box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.13);
				color: #FFFFFF;
				cursor: pointer;
			}
		}
	}
</style>
